import React from 'react';
import { Plus } from 'lucide-react';

const EmptyState = ({ message, buttonText, onButtonClick }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4 text-center">
      <div className="text-gray-400 mb-4">
        <Plus size={48} className="mx-auto" />
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-1">{message}</h3>
      {buttonText && (
        <button
          onClick={onButtonClick}
          className="mt-4 px-4 py-2 bg-secondary text-white rounded-md font-medium text-sm transition-all hover:bg-secondaryDark"
        >
          {buttonText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;